export const types = {
    SET_BOOKS: 'directory/SET_BOOKS',
  }
  
  export const setBooks = (payload) => ({
    type: types.SET_BOOKS,
    payload,
})